<template>
    <div class="row page-row report">
        <div class="col-md-2 reports">
            <div class="form-group mt-3">
                <label for="headline"> Headline</label>
                <!-- @input="report.title = $event.target.value.replace(/[^a-zA-Z0-9 ]/g, '')" -->
                <input v-if="report" id="headline" class="headline form-control" type="text" maxlength="255"
                       :value="report.title" @input="report.title = $event.target.value"
                       placeholder="Headline">
            </div>

            <hr/>
            <ul class="pages">
                <li v-for="pageItem in pages" :class="pageItem.page === page.page ? 'selected' : ''"
                    v-on:click="changePage(pageItem)">
                    <a href="javascript:void(0)" title="">
                        Layout{{ pageItem.page }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="col-md-10 editor">
            <div class="tools">
                <b-button class="toolSwitch" :class="projectToolsActive ? 'active' : ''" size="sm" @click="projectToolsActive = !projectToolsActive">
                    Site Tools
                </b-button>
                <div class="basic" v-if="!projectToolsActive">
                    <b-button class="text" v-bind:class="{ active: (activeTool == 'note') }" v-b-tooltip.hover
                              title="Note"
                              v-on:click="activeTool = (activeTool == 'note' ? null : 'note')">
                    </b-button>
                    <b-button class="ruler" v-bind:class="{ active: (activeTool == 'measure') }" v-b-tooltip.hover
                              title="Measure"
                              v-on:click="activeTool = (activeTool == 'measure' ? null : 'measure')">
                    </b-button>
                    <b-button class="picture" v-bind:class="{ active: (activeTool == 'gallery') }" v-b-tooltip.hover
                              title="Gallery"
                              v-on:click="activeTool = (activeTool == 'gallery' ? null : 'gallery')">
                    </b-button>
                    <b-button class="checkbox" v-bind:class="{ active: (activeTool == 'checkbox') }" v-b-tooltip.hover
                              title="Checkbox"
                              v-on:click="activeTool = (activeTool == 'checkbox' ? null : 'checkbox')">
                    </b-button>
                </div>
                <div class="company" v-else>
                    <template v-if="projectTools.length > 0">
                        <button v-for="tool in projectTools" :key="tool.id" v-bind:class="{ active: (activeProjectTool === tool) }"
                                @click="setActiveProjectTool(tool)">{{ tool.short_name.toUpperCase() }}
                        </button>
                    </template>
                </div>

                <b-button :class="'save ' + (isSaving ? ' is_saving' : '')" v-on:click="saveReport" v-b-tooltip.hover
                          title="Save">
                    <b-spinner small v-if="isSaving" variant="danger"></b-spinner>
                </b-button>

                <b-button :class="'switch ' + (isChangingLayout ? 'is_changing' : '')" v-on:click="confirmLayoutChange"
                          v-b-tooltip.hover title="Change layout(s)">
                    <b-spinner small v-if="isChangingLayout" variant="danger"></b-spinner>
                </b-button>
            </div>

            <Editor v-if="showEditor" :marking="currentMarking" v-on:saveMarking="saveMarking"
                    :project-tools="projectTools"
                    v-on:deleteMarking="showConfirmDeleteDialog" v-on:cancelEditMarking="cancelEditMarking"></Editor>

            <div class="pdfContainer">
                <PdfDocumentMobile id="pdfPages"
                                   ref="pdfDoc"
                                   v-if="file && file.id && pages.length"
                                   :active-tool="activeTool"
                                   :active-project-tool="activeProjectTool"
                                   :file="file"
                                   :pages="pages"
                                   :markings="markings"
                                   :showEditor="showEditor"
                                   :markingColor="selectedColor"
                                   :selectedMarking="selectedMarking"
                                   :paginateToPage="currentPage"
                                   :projectTools="projectTools"
                                   :hiddenMarkingTypes="[]"
                                   :fileID="file.id"
                                   :moveMode="moveMode"
                                   v-on:editMarking="editMarking"
                                   v-on:resetSelectedMarking="selectedMarking = null"
                                   v-on:deleteMarking="showConfirmDeleteDialog"
                                   v-on:toggleMoveMode="toggleMoveMode"
                                   v-on:temporaryMarkingChange="temporaryMarkingChange"
                ></PdfDocumentMobile>
            </div>
        </div>


        <FileLoader id="FileLoader" v-if="newFile" :file="newFile" v-on:finished="changeLayouts"></FileLoader>

        <input type="file" id="fileInput" ref="fileInput" v-on:change="uploadFile()" accept="application/pdf"
               placeholder=""/>

        <div class="move-navigation" v-if="moveMode">
            <p>Moving marking</p>
            <button v-on:click="toggleMoveMode( false)">Done</button>
        </div>

        <div v-if="temporaryMarking" class="move-navigation">
            <p>Add more points</p>
            <button v-if="temporaryMarking.points.length > 1" @click="saveTemporaryMarking">Done</button>
        </div>

    </div>
</template>


<script>
import '@css/report.css';
import PdfDocumentMobile from '@mobile/components/edit_mobile/PdfDocumentMobile';
import FileLoader from "@mobile/components/global/FileLoader";
import Editor from '@mobile/components/edit/Editor';
import {reportUtils} from '@mobile/utils/report-utils';


export default {
    components: {PdfDocumentMobile, Editor, FileLoader},
    data() {
        return {
            activeUser: null,
            project: null,
            report: null,
            file: false,
            markings: [],
            pages: [],
            activeTool: null,
            showEditor: false,
            markingColors: {
                black: '#000000',
                blue: '#016080',
                yellow: '#ffcd41',
                green: '#17a05d',
                magenta: '#c72765',
                orange: '#f3996f',
            },
            selectedColor: '#000000',
            selectedMarking: null,
            moveMode: 0,
            currentPage: null,
            page: null,
            panInstance: null,
            scale: 5,
            transform: {
                x: 0, // initial x position
                y: 0, // initial y position
                scale: 1  // initial zoom
            },
            initialScale: null,
            quickMenuIsVisible: false,
            quickMenuX: null,
            quickMenuY: null,
            quickMenuMarking: null,
            quickMenuMarkingIndex: null,
            moveMarkingIndex: null,
            originalWidth: null,
            originalHeight: null,
            currentMarkingIndex: null,
            currentMarking: null,

            newFile: false,
            isSaving: false,
            isChangingLayout: false,
            noLeaveMessage: false,
            projectTools: [],
            activeProjectTool: null,
            projectToolsActive: false,
            temporaryMarking: null
        }
    },
    watch: {
        // 'project.id': function () {
        //     this.getReport();
        // }
    },
    computed: {},
    beforeRouteEnter: function (to, from, next) {
        next(function (vm) {
            vm.getReport();
            vm.loadProjectTools();
        });
    },
    beforeRouteUpdate: function (to, from, next) {
        next();
        this.loadProjectTools();
        this.getReport();
    },
    mounted() {
        this.project = this.$store.state.project;
    },
    methods: {
        getReport() {
            if (!this.$store.state.project.id) {
                return;
            }

            this.markings = [];

            if(this.$route.params.report_id){
                let reportId = this.$route.params.report_id;
                this.$store.dispatch('loadReport', reportId).then((report) => {
                    report.title = (report.title ? report.title : 'Untitled').replace(' (edited)', '') + ' (edited)';
                    this.report = report;

                    if (report.markings && report.markings.length > 0) {

                        report.markings.forEach(marking => {
                            marking.attachments = [];
                            if (marking.groupped_attachments && marking.groupped_attachments.length > 0) {
                                marking.groupped_attachments.forEach(attachments => {
                                    if (attachments.length > 0) {
                                        attachments.forEach(attachment => {
                                            marking.attachments.push(attachment);
                                        });
                                    }

                                });
                                delete marking.groupped_attachments;
                            }
                            this.markings.push(marking);
                        });
                    }
                    this.file = report.file;
                    this.file.id = report.id;
                    this.pages = report.pages;
                    this.currentPage = 1;
                    this.page = this.pages[0];

                });
            }
            else if(this.$route.params.file_id){
                let fileID = this.$route.params.file_id;

                this.$store.dispatch('APIgetFileWithMarkings', {file_id: fileID}).then((data) => {

                    this.file = {
                        id: data.file.id,
                        project_id: data.file.project_id,
                        name: data.file.file.name,
                        url: data.file.file.url
                    };

                    this.currentPage = 1;
                    this.pages = data.file.pages;
                    this.page = this.pages[0];
                    this.report = {
                        title: ''
                    }

                    if (data.markings && data.markings.length > 0) {

                        data.markings.forEach(marking => {
                            marking.attachments = [];
                            if (marking.groupped_attachments && marking.groupped_attachments.length > 0) {
                                marking.groupped_attachments.forEach(attachments => {
                                    if (attachments.length > 0) {
                                        attachments.forEach(attachment => {
                                            marking.attachments.push(attachment);
                                        });
                                    }

                                });
                                delete marking.groupped_attachments;
                            }
                            this.markings.push(marking);
                        });
                    }
                });
            }
        },
        loadProjectTools(){
            this.$store.dispatch('APIgetProjectTools', this.$store.state.project.id).then(tools => {
                this.projectTools = tools ? tools : [];
            });
        },
        editMarking(markingIndex) {
            if (typeof this.markings[markingIndex] !== 'undefined') {
                this.activeTool = null;
                this.activeProjectTool = null;
                this.showEditor = true;
                this.currentMarking = this.markings[markingIndex];
                this.currentMarkingIndex = markingIndex;
            }
        },
        showConfirmDeleteDialog(markingIndex) {
            if (typeof markingIndex !== 'undefined' && markingIndex !== null) {
                this.currentMarkingIndex = markingIndex;
            }

            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this marking?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'md',
                okVariant: 'danger',
                okTitle: 'Delete',
                cancelTitle: 'Cancel',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    this.deleteMarking();
                }
            });

            this.confirmDeleteDialogIsVisible = true;
        },
        changePage(pageItem) {
            this.page = pageItem;
            this.currentPage = pageItem.page;
        },
        saveMarking(marking) {
            if (this.currentMarking !== null && this.currentMarkingIndex !== null) {
                marking.is_new = false;
                this.markings[this.currentMarkingIndex] = marking;
            }
            this.hideEditor();
        },
        deleteMarking() {
            this.confirmDeleteDialogIsVisible = false;

            if (typeof this.markings[this.currentMarkingIndex] !== 'undefined') {
                this.markings.splice(this.currentMarkingIndex, 1);
            }

            this.hideEditor();
        },
        cancelEditMarking() {
            this.hideEditor();
        },
        hideEditor() {
            this.currentMarking = null;
            this.currentMarkingIndex = null;
            this.showEditor = false;
            this.activeTool = null;
        },
        toggleMoveMode(moveMode) {
            this.moveMode = moveMode ? 1 : 0;
            this.$forceUpdate();
        },

        saveReport() {
            if (this.isSaving)
                return;

            this.$bvModal.msgBoxConfirm('Are you sure you want to save? This action will create a new report.', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'md',
                okVariant: 'danger',
                okTitle: 'Proceed',
                cancelTitle: 'Cancel',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.$store.state.isLoading = true;
                        this.$store.state.loadingText = 'Preparing to save report';
                        this.isSaving = true;

                        console.log(this.file, 'this is the file');
                        console.log(this.pages, 'pages');
                        console.log(this.markings, 'markings');

                        reportUtils.prepareReportData(this.file, this.pages, this.markings, this.$store.state).then(formData => {
                            let reportID = this.$route.params.report_id;
                            formData.set('title', this.report.title);
                            formData.set('project_id', this.$store.state.project.id);

                            return this.$store.dispatch('updateReport', {reportID, formData})
                                .then((newReport) => {
                                    this.$store.state.isLoading = false;

                                    this.$bvModal.msgBoxConfirm('New report was created successfully.', {
                                        title: 'Report created',
                                        size: 'md',
                                        buttonSize: 'md',
                                        okVariant: 'danger',
                                        okTitle: 'Preview new report',
                                        cancelTitle: 'Stay on this page',
                                        centered: true
                                    }).then(res => {
                                        if(res){
                                            this.noLeaveMessage = true;
                                            this.$router.push({ name: 'projects-reports-view', params: { id: this.$store.state.project.id, report_id: newReport.id } })
                                        }
                                    });

                                    this.isSaving = false;

                                })
                                .catch(err => {
                                    alert('Failed to delete markings before save');
                                    console.log(err);
                                });
                        }).catch(err => {
                            console.log(err, 'err');
                        });
                    }
                })
                .catch(err => {
                    // An error occurred
                });


        },

        confirmLayoutChange() {

            this.$bvModal.msgBoxConfirm('Are you sure you want to change the layout(s)?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'md',
                okVariant: 'danger',
                okTitle: 'Proceed',
                cancelTitle: 'Cancel',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    this.$refs.fileInput.click();
                }
            });
        },

        uploadFile() {

            /*
              Set the local file variable to what the user has selected.
            */
            let file = this.$refs.fileInput.files[0];
            if (file) {
                let reader = new FileReader();
                let that = this;
                this.isChangingLayout = true

                reader.readAsArrayBuffer(file);

                reader.onload = function (evt) {

                    let fileName = file.name;
                    let pos = fileName.lastIndexOf(".");
                    fileName = fileName.substr(0, pos < 0 ? fileName.length : pos) + ".dotag";


                    that.file.content = new Blob([evt.target.result], {type: file.type});
                    that.file.url = URL.createObjectURL(that.file.content);
                    that.file.name = fileName;
                    that.newFile = that.file;
                };

                reader.onerror = function (err) {
                    console.log(err, 'errr');
                    that.isChangingLayout = false;
                };

            }
        },
        changeLayouts(newPages) {


            console.log(this.pages, 'le old pages');

            this.pages = [];
            this.file = false;
            const newFile = this.newFile;

            newPages.forEach(page => {
                this.pages.push({
                    file_id: this.file.id,
                    width: page.width,
                    height: page.height,
                    page: page.page,
                    content: page.content,
                    url: URL.createObjectURL(page.content),
                });
            });

            setTimeout(() => {
                this.file = newFile;
                this.newFile = false;

                this.isChangingLayout = false;

                this.$bvModal.msgBoxOk('Layout was switched successfully.', {
                    title: 'Layout switched',
                    size: 'md',
                    buttonSize: 'md',
                    okVariant: 'danger',
                    centered: true
                });
            }, 500);
        },
        setActiveProjectTool(tool) {
            if (this.activeProjectTool === tool) {
                this.activeProjectTool = null;
            } else {
                this.activeTool = null;
                this.activeProjectTool = tool;
            }
        },
        temporaryMarkingChange(marking) {
            this.temporaryMarking = marking;
        },
        saveTemporaryMarking() {
            this.temporaryMarking = null;
            this.activeProjectTool = null;
            this.activeTool = null;

            this.$refs.pdfDoc.$refs.pdfPage.saveTemporaryMarking();
        }
    },
    beforeRouteLeave (to, from , next) {
        if(this.noLeaveMessage) {
            next();
        } else {
            this.$bvModal
                .msgBoxConfirm('Do you really want to leave? All your changes will be discarded.', {
                    title: 'Confirmation',
                    size: 'md',
                    buttonSize: 'md',
                    okVariant: 'danger',
                    okTitle: 'Proceed',
                    cancelTitle: 'Cancel',
                    hideHeaderClose: false,
                    centered: true
            }).then(value => value ? next() : next(false));
        }
    }
}
</script>

<style scoped>
#fileInput {
    display: none;
}
.move-navigation {
    text-align: left;
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    height: 50px;
    justify-content: flex-end;
    background-color: white;
    box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.16);
    font-size: 13px;
    padding-left: 20px;
    z-index: 5;
}
.move-navigation p {
    display: block;
    padding: 10px 0 0 80px;
    margin: 0;
    font-size: 20px;
    text-align: center;
}
.move-navigation button {
    margin: 0;
    border: 0;
    background-color: #E10613;
    color: white;
    font-size: 18px;
    line-height: 30px;
    text-transform: capitalize;
    padding: 0 40px;
    box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.16);
    float: right;
    top: 0;
    right: 0;
    position: absolute;
    height: 50px;
}
#headline {
    height: 35px;
    padding-left: 5px;
}
</style>
